import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Articles from "./sections/Articles";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <Hero />
      <Articles />
      <Footer />
    </div>;
}